import { useContext } from 'react';
import PropTypes from 'prop-types';

import { ResponsiveContext } from '../../../Providers/Responsive';
import MultiColumnLayout from '../MultiColumnLayout';

import PointsMobileCarousel from './PointsMobileCarousel';

export const PointsTileCards = ({ data = null, className = '' }) => {
  const { mobile } = useContext(ResponsiveContext);

  const carouselView = data.elements.length > 4;

  return mobile || carouselView ? (
    <PointsMobileCarousel data={data} className={className} />
  ) : (
    <MultiColumnLayout
      data={data}
      componentType="points-tile"
      className={data.component}
    />
  );
};

PointsTileCards.propTypes = {
  data: PropTypes.shape(),
  className: PropTypes.string,
};
